<template>
  <sea-page title="Cestino" showCompanyHeader header="Cestino">
    <sea-page-content
      ref="list"
      :fetchList="fetchList"
      :resetList="resetList"
      :items="items"
      toolbar
      hide-data-pub
      pulsanteAggiorna
      pulsanteCronologia
      :deleteList="deleteSelected"
      :recycleList="recycleBinSelected"
      pulsanteEliminaDalCestino
      pulsanteRipristina
    >
      <template v-slot:table="{ attrs, height }">
        <v-data-table
          v-model="attrs.selected"
          v-bind="attrs"
          :height="height"
          :headers="headers"
          :items="filteredItems"
          sort-by="descrizione"
          dense
          show-select
          @click:row="rowClick"
          @item-selected="itemSelected"
        >
          <template v-slot:header.tags="{ props, on }">
            <v-menu
              offset-y
              :close-on-content-click="false"
              v-bind="props"
              v-on="on"
            >
              <template v-slot:activator="{ on, attrs }">
                Tag
                <v-icon v-bind="attrs" v-on="on"> mdi-menu-down </v-icon>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      @click="selectedTags = []"
                      v-model="allTags"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-title>Tutti</v-list-item-title>
                </v-list-item>
                <v-list-item v-for="(tag, index) in list" :key="index">
                  <v-list-item-action>
                    <v-checkbox
                      @click="addRemove(tag.text)"
                      v-model="tag.active"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-title>{{ tag.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <template v-slot:item.visualizza="{ item }">
            <v-btn
              elevation="2"
              rounded
              x-small
              @click="download(item)"
              :color="colors.primarycolor"
              dark
            >
              Apri
              <v-icon right>mdi-open-in-new </v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </template>
    </sea-page-content>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import mixin from "@/mixin";

const headers = [
  {
    text: "Tag",
    value: "tags",
    sortable: false,
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Titolo",
    value: "descrSintetica",
    class: "heading",
    cellClass: "text-little-2 hand",
  },
  {
    text: "Visualizza",
    value: "visualizza",
    sortable: false,
    filterable: false,
    class: "heading",
    cellClass: "text-little-2 hand",
  },
];

export default {
  name: "cestino",
  mixins: [mixin],
  data() {
    return {
      file: null,
      headers,
      tags: [],
      allTags: true,
      selectedTags: [],
      currentRow: null,
    };
  },
  mounted() {},
  methods: {
    ...mapActions({
      fetchList: "proxy/fetchRecycleBin",
      resetList: "proxy/resetRecycleBin",
      delete: "proxy/deleteDocument",
      download: "proxy/downloadDocument",
    }),

    rowClick: function (_, row) {
      row.select(!row.isSelected);
    },
    itemSelected(payload) {
      this.currentRow = payload.value ? payload.item : null;
    },
    confirm() {
      this.$refs.list.openDeleteConfirm();
    },
    resetTags() {
      this.selectedTags = [];
      this.allTags = true;
    },
    async deleteSelected() {
      await this.delete(this.currentRow.id);
      this.currentRow = null;
      await this.$refs.list.updateList();
    },
    async recycleBinSelected() {
      await this.recycleBin(this.currentRow.id);
      this.currentRow = null;
      await this.$refs.list.updateList();
    },
  },
  computed: {
    ...mapGetters({
      items: "proxy/recycleBin",
      list: "proxy/recycleBinTags",
    }),

    filteredItems() {
      return this.allTags
        ? this.items
        : this.items.filter((item) => this.selectedTags.indexOf(item.tag) > -1);
    },
  },
  watch: {
    selectedTags() {
      if (this.selectedTags.length == 0) {
        this.allTags = true;
        this.tags.forEach((tag) => {
          tag.active = false;
        });
      } else {
        this.allTags = false;
      }
    },
  },
};
</script>

<style>
</style>
